import { useResourceBundles } from '../../contexts/resource-bundles-context';
import TenantConsentsPage from './tenant-consents-page';

function TenantConsentsMentorsPage() {
  const { rb } = useResourceBundles();

  return (
    <TenantConsentsPage
      filterType='Mentor'
      pageTitle={`${rb('mentor-u')} Commitments`}
      pageDescription={`Here you can create and modify commitments for ${rb(
        'mentors',
      )}.`}
    />
  );
}

export default TenantConsentsMentorsPage;
